import type { PropsWithChildren } from 'react';

import Button from '@ingka/button';
import Modal, { ModalFooter, ModalHeader, Prompt } from '@ingka/modal';
import { translate } from '@repo/phrase';

interface Props {
    visible: boolean;
    title: string;
    onClose: () => void;
    primaryButtonProps: {
        text: string;
        onClick: () => void;
        loading?: boolean;
        disabled?: boolean;
    };
    secondaryButtonProps: {
        text: string;
        onClick: () => void;
        loading?: boolean;
        disabled?: boolean;
    };
}

export const DialogModal = ({
    visible,
    title,
    primaryButtonProps,
    secondaryButtonProps,
    onClose,
    children,
}: PropsWithChildren<Props>) => {
    return (
        <Modal visible={visible} handleCloseBtn={onClose} data-testid="dialog-modal">
            <Prompt
                describedById="order taking dialog modal"
                titleId="order_taking_dialog_modal_title"
                title={title}
                header={<ModalHeader ariaCloseTxt={translate('dialog_modal_header_close')} />}
                footer={
                    <ModalFooter>
                        <Button
                            text={secondaryButtonProps.text}
                            type="secondary"
                            onClick={secondaryButtonProps.onClick}
                            loading={secondaryButtonProps.loading ?? false}
                            disabled={secondaryButtonProps.disabled ?? false}
                        />
                        <Button
                            type="primary"
                            text={primaryButtonProps.text}
                            onClick={primaryButtonProps.onClick}
                            loading={primaryButtonProps.loading ?? false}
                            disabled={primaryButtonProps.disabled ?? false}
                        />
                    </ModalFooter>
                }
            >
                {children}
            </Prompt>
        </Modal>
    );
};
